// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import { color } from '../../../styles/theme';

export default class NewView extends JQueryView {
  constructor() {
    super('.company.rightholders');
  }

  @on({ event: 'change', selector: 'input[name="select_stakeholder"]:radio' })
  onChangeSyncStockholder() {
    const target = $('#js_select_area');
    if ($('#select_stakeholder_true').is(':checked')) {
      target.removeClass('d-none');
      $(
        `#stakeholder_last_name, #stakeholder_first_name,
         #stakeholder_email, #stakeholder_zip_code, #stakeholder_prefecture,
         #stakeholder_city, #stakeholder_address, #stakeholder_address_detail`,
      )
        .prop('disabled', true)
        .val('');
      $('#select_stakeholder_id').prop('selectedIndex', 0);
      $(
        `#stakeholder_holder_type_user, #stakeholder_holder_type_company,
         #stakeholder_overseas_false, #stakeholder_overseas_true`,
      )
        .parent()
        .css({ 'background-color': color.smokeWhite });
      $('#stakeholder_holder_type_user')
        .trigger('click')
        .val('User');
      $('#stakeholder_holder_type_company').prop('disabled', true);
      $('#stakeholder_overseas_false')
        .prop('disabled', false)
        .prop('checked', true);
      $('#stakeholder_overseas_true').prop('disabled', true);
      $(
        '.stakeholder_prefecture, .stakeholder_city, .stakeholder_address_detail',
      ).show();
      $('#stakeholder_address').removeClass('rounded-bottom');
      $('#address_button').hide();
    } else {
      target.addClass('d-none');
      this.renderNewForm();
    }
  }

  @on({ event: 'change', selector: '#select_stakeholder_id' })
  changeTemplate() {
    const target = $('#select_stakeholder_id');
    var select_stakeholder_id = target.val();
    if (select_stakeholder_id) {
      this.renderEditForm(select_stakeholder_id);
    } else {
      $('#select_stakeholder_false').trigger('click');
    }
  }

  renderEditForm(select_stakeholder_id: number) {
    //itou バリデーションエラーで入力画面に戻るとなぜか参照されるルートパスが変わってしまうため遷移先URLを動的に定義する暫定対応
    const url =
      location.pathname == '/company/rightholders'
        ? `rightholders/${select_stakeholder_id}/edit`
        : `${select_stakeholder_id}/edit`;
    $.ajax({
      url: url,
      type: 'GET',
      data: {
        select_stakeholder_id: select_stakeholder_id,
      },
      dataType: 'script',
    });
  }
  renderNewForm() {
    //itou バリデーションエラーで入力画面に戻るとなぜか参照されるルートパスが変わってしまうため遷移先URLを動的に定義する暫定対応
    const url =
      location.pathname == '/company/rightholders' ? 'rightholders/new' : 'new';
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'script',
    });
  }
}
